import Table from 'src/MarketDataComponents/Table';
import { formatPrice, formatNumber } from "src/MarketDataComponents/Helpers";
import moment from "moment";

export default function Dividends({dividends, quote}) {
    
    const displayAmount = (dividend) => {
        const { currency, amount } = dividend;

        if (currency === 'GBP') {
            return `${formatNumber((amount * 100), 2)}p`;
        }

        return formatPrice(currency, amount);
    }

    const DividendsComponent = ({defaultTableClassName, latest, previous, moreLink}) => {
        let theadRows = [];

        if (previous !== undefined) {
            theadRows.push(
                <tr key="headrow-1">
                    <th></th>
                    <th data-testid="dividendPreviousTableHead">Previous</th>
                    <th data-testid="dividendLatestTableHead">Latest</th>
                </tr>
            );
        }

        const tbodyRows = [
            <tr key="1">
                <th scope="row" data-testid="dividendRecordDateTableRow">Record date</th>
                {previous !== undefined &&
                <td aria-label="Previous" data-testid="dividendPreviousRecordDate">{previous.recordDate}</td>
                }
                <td aria-label="Latest" data-testid="dividendLatestRecordDate">{latest.recordDate}</td>
            </tr>,
            <tr key="2">
                <th scope="row" data-testid="dividendExDateTableRow">Ex-dividend date</th>
                {previous !== undefined &&
                <td aria-label="Previous" data-testid="dividendPreviousExDate">{previous.exDivDate}</td>
                }
                <td aria-label="Latest" data-testid="dividendPreviousExDate">{latest.exDivDate}</td>
            </tr>,
            <tr key="3">
                <th scope="row" data-testid="dividendPaymentDateTableRow">Payment date</th>
                {previous !== undefined &&
                <td aria-label="Previous" data-testid="dividendPreviousPaymentDate">{previous.payDate}</td>
                }
                <td aria-label="Latest" data-testid="dividendPreviousPaymentDate">{latest.payDate}</td>
            </tr>,
            <tr key="4">
                <th scope="row" data-testid="dividendAmountDateTableRow">Amount</th>
                {previous !== undefined &&
                <td aria-label="Previous" data-testid="dividendPreviousAmountDate">{previous.amount}</td>
                }
                <td aria-label="Latest" data-testid="dividendPreviousAmountDate">{latest.amount}</td>
            </tr>
        ];

        return <Table defaultClassName={defaultTableClassName} theadRows={theadRows} tbodyRows={tbodyRows} />;
    }
 
    const renderDividends = () => {

        const dividendsToRender = [];

        for (let d in dividends) {
            for (let i = 0; i < 2; i++) {
                dividendsToRender.push({
                    exDivDate: moment(dividends[i].exDivDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    payDate: moment(dividends[i].payDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    recordDate: moment(dividends[i].recordDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    amount: displayAmount(dividends[i])
                });
            }
            dividendsToRender.push(dividends[d]);
        }

        if (dividendsToRender && dividendsToRender.length > 1) {
            return <DividendsComponent 
                defaultTableClassName={'data-table data-table--small data-table--scroll margin-0'}
                latest={dividendsToRender[0]} 
                previous={dividendsToRender[1]} 
                moreLink={`${process.env.NEXT_PUBLIC_BASE_PATH}/sub/${quote.marketCode}/dividends`}
            />
        }

        return null;
    }

    return dividends && dividends.length > 1 ? <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm" id="newsContent">
            <h2 className="card-title" data-testid="overviewDividendsHeader">Dividends</h2>
            {renderDividends()}
        </div>
    </div> : null
}